var NetworkManager = require('./NetworkManager');

var LocalizationManager = {
    LOCALE : null,
    ACCOUNTID : null,  
    DOMAIN : null,
    CACHE_AVAILABLE : null,
    LOCALE : window.navigator.userLanguage || window.navigator.language,

    shared : function()
    {
        if( typeof window.localizationManager === 'undefined' || window.localizationManager == null )
        {
            window.localizationManager = this;
        }
        this.ACCOUNTID = this.findGetParameter('accountID');
        var self = this;

        this.shouldForceUpdateCache( (shouldUpdateCache) =>
        {   
            if(shouldUpdateCache){
                self.clearCache();
                localStorage.setItem('CACHE_NEEDS_UPDATE', "true");  
                document.location.reload();
            }
        });       

        return window.localizationManager;
    },

    shouldForceUpdateCache: function(completion)
    {
        var self = this;
        var cachedLocalizationVersion = localStorage.getItem('CACHE_VERSION');
        NetworkManager.checkCacheVersion(this.LOCALE, cachedLocalizationVersion, this.ACCOUNTID).then((response) =>
        {   
            localStorage.setItem('CACHE_VERSION', response.localizationVersion);            
            completion(response.translatedStrings.shouldUpdateTranslations || localStorage.getItem('USER_LOCALE') == null || localStorage.getItem('USER_LOCALE') != self.LOCALE)
        });       
    },

    initializeCache : function(ACCOUNTID, locale)
    {
        this.LOCALE = locale;
        var cachedLocale = localStorage.getItem('USER_LOCALE');
        if( cachedLocale == null ) localStorage.setItem('USER_LOCALE', locale);
        else if( cachedLocale != locale ){
            localStorage.setItem('USER_LOCALE', locale);
        }

        this.CACHE_AVAILABLE = this.storageAvailable('localStorage');
    },

    // first check if strings exist in cache, if they do exist in cache dont make AJAX call
    _isFetchingStrings : false,
    _pendingLocaleKeys : [],
    _pendingLocaleParamss : [],
    _pendingCompletions : [],
  
    localizedStringForKey : function(localeKey, localeParams = [], completion)
    {
        this.localizedStringsForKeys([localeKey], [localeParams], (localizedStrings)=>
        {
            completion(localizedStrings[0]);
        })
    },

    localizedStringsForKeys : function(localeKeys, localeParamss, completion)
    {
        var self = this;
        if( localeParamss == null )
        {
            localeParamss = [];
            for( var i = 0; i < localeKeys.length; i++ ) localeParamss.push([]);
        }

        var uncachedLocaleKeys = [];
        var uncachedLocaleParamss = [];
        var uncachedIndices = [];
        var cachedLocalizedStrings = [];
        var shouldDoUpdate = false;
        if( localStorage.getItem('USER_LOCALE') != this.LOCALE || localStorage.getItem("CACHE_NEEDS_UPDATE") == "true")
        {
            this.clearCache();
            this.initializeCache(this.ACCOUNTID, this.LOCALE);
        } 

        for( var i = 0; i < localeKeys.length; i++ )
        {
            var cachedLocalizedString = this.getFromCache(localeKeys[i], localeParamss[i]);
            if( cachedLocalizedString == null )
            {
                shouldDoUpdate = true;
                uncachedLocaleKeys.push(localeKeys[i]);
                uncachedLocaleParamss.push(localeParamss[i]);
                uncachedIndices.push(i);
                cachedLocalizedStrings.push("");
            }
            else
            {
                cachedLocalizedStrings.push(cachedLocalizedString);
            }
        }

        if( !shouldDoUpdate )
        {
            completion(cachedLocalizedStrings);
            return;
        }

        if( this._isFetchingStrings )
        {
            this._pendingLocaleKeys.push(localeKeys);
            this._pendingLocaleParamss.push(localeParamss);
            this._pendingCompletions.push(completion);
            return;
        }  
        this._isFetchingStrings = true;
        NetworkManager.getLocalizedStrings(this.LOCALE, uncachedLocaleKeys, uncachedLocaleParamss, this.ACCOUNTID).then((payload) =>
        {   
            for( var i = 0; i < uncachedLocaleKeys.length; i++ )
            {
                self.addCacheLocKey(uncachedLocaleKeys[i], uncachedLocaleParamss[i], payload.translatedStrings[i]);
                cachedLocalizedStrings[uncachedIndices[i]] = payload.translatedStrings[i];
            }
            self.cleanUpCache();
            self._isFetchingStrings = false;
            self.checkPending();
            localStorage.setItem("CACHE_NEEDS_UPDATE", "false");
            completion(cachedLocalizedStrings);
        });
    },

    checkPending : function()
    {
        if( this._pendingLocaleKeys.length <= 0 ) return;

        var joinedPiecesSizes = [];
        var joinedPendingLocaleKeys = [];
        for( var i = 0; i < this._pendingLocaleKeys.length; i++ )
        {
            joinedPendingLocaleKeys = joinedPendingLocaleKeys.concat(this._pendingLocaleKeys[i]);
            joinedPiecesSizes.push(this._pendingLocaleKeys[i].length)
        }
        
        var joinedPendingLocaleParamss = [];
        for( var i = 0; i < this._pendingLocaleParamss.length; i++ ) joinedPendingLocaleParamss = joinedPendingLocaleParamss.concat(this._pendingLocaleParamss[i]);

        var joinedPendingCompletions = [];
        for( var i = 0; i < this._pendingCompletions.length; i++ ) joinedPendingCompletions.push(this._pendingCompletions[i]);

        this._pendingLocaleKeys = [];
        this._pendingLocaleParamss = [];
        this._pendingCompletions = [];
        this.localizedStringsForKeys(joinedPendingLocaleKeys, joinedPendingLocaleParamss, (joinedLocalizedStrings) =>
        {
            var movingIndex = 0;
            for( var i = 0; i < joinedPiecesSizes.length; i++ )
            {
                var endIndex = movingIndex + joinedPiecesSizes[i];
                var separatedLocalizedStrings = joinedLocalizedStrings.slice(movingIndex,endIndex);
                joinedPendingCompletions[i](separatedLocalizedStrings);
                movingIndex = endIndex;
            }
        })
    },

    _onPageLocKeys : [],
    _currentCacheSize : 0,
    addCacheLocKey : function(localeKey, localeParams, localizedString) 
    {
        var self = this;
        var hashedKey = this.getHashedLocKey(localeKey, localeParams);
        var shouldAddThisToCache = this.shouldAddToCache(localeKey, localeParams, hashedKey, localizedString);

        // if we should add this item to cache, set the hashed key in local storage and remove the hashedkey
        // from our "queue" of keys
        if( shouldAddThisToCache )
        {
            localStorage.setItem(hashedKey, localizedString);
            var currentCacheSize = this.getCurrentCacheSize();
            this.setCurrentCacheSize(currentCacheSize + localizedString.length);
            var currentLocKeyArray = this.getCacheLocKeyArray();
            currentLocKeyArray.unshift(hashedKey);
            this.setCacheLocKeyArray(currentLocKeyArray);
            this._onPageLocKeys.push(hashedKey);
        }
    },

    clearCache : function()
    {
        var locKeyArray = this.getCacheLocKeyArray();
        for( var i = 0; i < locKeyArray.length; i++ )
        {
            var hashedKey = this.getHashedLocKey(locKeyArray[i]);
            localStorage.removeItem(hashedKey);
        }
        this._currentCacheSize = 0;
        this.setCurrentCacheSize(this._currentCacheSize);
        this.setCacheLocKeyArray([])
    },

    getFromCache : function(localeKey, localeParams = null)
    {
        var hashedKey = this.getHashedLocKey(localeKey, localeParams);

        return localStorage.getItem(hashedKey);
    },

    _currentCacheSize : -1,
    getCurrentCacheSize : function()
    {
        if( this._currentCacheSize < 0 ) 
        {
            this._currentCacheSize = localStorage.getItem("CACHE_SIZE");
            if( typeof this._currentCacheSize === 'string' ) this._currentCacheSize = parseInt(this._currentCacheSize);
        }
        if( this._currentCacheSize === null ) this._currentCacheSize = 0;

        return this._currentCacheSize;
    },

    setCurrentCacheSize : function(newSize)
    {
        this._currentCacheSize = newSize;
        localStorage.setItem("CACHE_SIZE", newSize);
    },

    getHashedLocKey : function(localeKey, localeParams = null) 
    {
        var hashedLocKey = localeKey;
        if( localeParams != null && localeParams.length > 0 )
        {
            for( var i = 0; i < localeParams.length; i++ )
            {
                hashedLocKey += "-" + localeParams[i];
            }
        }
        
        return hashedLocKey;
    },

    RECURSIVE_POP_LIMIT : 300,
    popFromCache : function(recursiveLevel = 0)
    {
        var cacheLocKeyArray = this.getCacheLocKeyArray();
        var keyToRemove = cacheLocKeyArray.pop();
        if( this._onPageLocKeys.contains(keyToRemove) && recursiveLevel < this.RECURSIVE_POP_LIMIT )
        {
            cacheLocKeyArray.unshift(keyToRemove);
            this.popFromCache(recursiveLevel+1);
            return;
        }
        var localizedString = localStorage.getItem(keyToRemove);
        if( localizedString == null ) 
        {
            console.log("loc error: could not find key ", keyToRemove)
            return false;
        }

        if( recursiveLevel == this.RECURSIVE_POP_LIMIT ) console.log("hit limit")

        var currentCacheSize = this.getCurrentCacheSize();
        this.setCurrentCacheSize(currentCacheSize - localizedString.length);
        localStorage.removeItem(keyToRemove);
        this.setCacheLocKeyArray(cacheLocKeyArray);    

        return true;
    },

    localeKeyArray : null,
    _CACHE_MAX_SIZE : 20000,
    cleanUpCache : function()
    {
        var currentCacheSize = this.getCurrentCacheSize();
        while( currentCacheSize >= this._CACHE_MAX_SIZE )
        {
            if( !this.popFromCache() ) break;
            currentCacheSize = this.getCurrentCacheSize();
        }
    },

    _cacheLocKeyArray : null,
    getCacheLocKeyArray : function()
    {
        if( this._cacheLocKeyArray == null ) 
        {
            this._cacheLocKeyArray = localStorage.getItem("reup-loc-key-array");
            if( this._cacheLocKeyArray != null ) this._cacheLocKeyArray = JSON.parse(this._cacheLocKeyArray);
        }

        if( this._cacheLocKeyArray == null ) this._cacheLocKeyArray = [];

        return this._cacheLocKeyArray;
    },

    shouldAddToCache : function(localeKey, localeParams, hashedKey = null, localizedString = null)
    {
        if( localeKey.includes("CONTEXTUAL") ) return false;
        if( localizedString == localeKey ) return false;
        if( hashedKey == null ) hashedKey = this.getHashedLocKey(localeKey, localeParams);
        if( localStorage.getItem(hashedKey) != null ) return false;

        return true;
    },

    setCacheLocKeyArray : function(cacheLocKeyArray)
    {
        this._cacheLocKeyArray = cacheLocKeyArray;
        localStorage.setItem("reup-loc-key-array", JSON.stringify(this._cacheLocKeyArray));
    },

    findGetParameter : function(parameterName) {
        var result = null,
            tmp = [];
        window.location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    },

    storageAvailable : function(type) {
        try {
            var storage = window[type],
                x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch(e) {
            return e instanceof DOMException && (
                // everything except Firefox
                e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' ||
                // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                // acknowledge QuotaExceededError only if there's something already stored
                storage.length !== 0;
        }
    }

}

module.exports = LocalizationManager.shared();